// @todo: Migrate to @wandb/components. For more details see:
// https://www.notion.so/wandbai/Migrating-components-207e2f5c7ef380129201f72a5770a8db
// eslint-disable-next-line wandb/no-deprecated-imports
import {Button} from '@wandb/weave/components/Button';
import React from 'react';

import DocUrls from '../../../util/doc_urls';
import {TargetBlank} from '../Link';
import {isLocalResourceType} from '../utils';
import {ResourceType} from '../utilTypes';
import * as S from './ZeroAgents.styles';

type ZeroAgentsProps = {
  resourceType: ResourceType;
  onAddAgent: () => void;
};

const RESOURCE_TYPE_NAMES: Partial<Record<ResourceType, string>> = {
  kubernetes: 'Kubernetes',
  sagemaker: 'SageMaker',
  vertex: 'GCP Vertex',
};
const RESOURCE_TYPE_HELP: Partial<Record<ResourceType, string>> = {
  kubernetes: 'You first need to create necessary resources in your cluster.',
  sagemaker: 'You first need to configure AWS credentials for your agent.',
  vertex: 'You first need to create the necessary GCP resources.',
};
const RESOURCE_TYPE_DOCS: Partial<Record<ResourceType, string>> = {
  kubernetes: DocUrls.launchKubernetes,
  sagemaker: DocUrls.launchSageMakerAgentConfiguration,
  vertex: DocUrls.launchVertex,
};

export const ZeroAgents = ({resourceType, onAddAgent}: ZeroAgentsProps) => {
  return (
    <S.Panel>
      <S.Circle>
        <S.LightBulb />
      </S.Circle>
      {!isLocalResourceType(resourceType) ? (
        <>
          <S.Heading>You'll need to configure and deploy an agent</S.Heading>
          <S.Message>
            You are launching on {RESOURCE_TYPE_NAMES[resourceType]}.<br />
            {RESOURCE_TYPE_HELP[resourceType]}
          </S.Message>
          {RESOURCE_TYPE_DOCS[resourceType] && (
            <TargetBlank href={RESOURCE_TYPE_DOCS[resourceType]}>
              <Button icon="documentation" variant="secondary" size="large">
                {'Launch on ' + RESOURCE_TYPE_NAMES[resourceType]}
              </Button>
            </TargetBlank>
          )}
        </>
      ) : (
        <>
          <S.Heading>No agents yet.</S.Heading>
          <S.Message>
            This queue needs an agent in order to start processing runs.
          </S.Message>
          <Button icon="add-new" size="large" onClick={onAddAgent}>
            Add an agent
          </Button>
        </>
      )}
    </S.Panel>
  );
};
